var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "flex flex-col gap-4", class: _vm.errorShow ? "error" : "" },
    [
      _c("label", { staticClass: "input-wrapp relative block" }, [
        _c("input", {
          staticClass:
            "block h-16 md:h-[72px] w-full text-base text-current font-medium px-8 input-border focus-visible:!border-current !outline-none duration-200",
          attrs: {
            type: _vm.type,
            name: _vm.name,
            placeholder: " ",
            autocomplete: _vm.autocomplete,
          },
          domProps: { value: _vm.value },
          on: { input: _vm.inputChange },
        }),
        _vm._v(" "),
        _c("span", {
          staticClass:
            "block absolute pointer-events-none whitespace-nowrap opacity-50 top-1/2 left-8 -translate-y-1/2 duration-200 will-change-transform",
          domProps: { textContent: _vm._s(_vm.placeholder) },
        }),
      ]),
      _vm._v(" "),
      _vm.errorShow
        ? _c("p", { staticClass: "text-xs text-red" }, [
            _vm._v(_vm._s(_vm.errorText)),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }